(function () {
  'use strict';

  var CONFIG_ID = 'wyr-region-gate-config';
  var DESTINATION_ORIGIN = 'https://wyrwear.me';
  var COOKIE_NAME = 'wyr_region';
  var COOKIE_DAYS = 60;
  var BYPASS_PARAMETER = 'wyr_region';
  var DEBUG_PARAMETER = 'wyr_region_debug';
  var DETECTION_TIMEOUT_MS = 2500;
  var PRIVACY_TIMEOUT_MS = 1500;
  var EVENT_TIMEOUT_MS = 500;
  var STYLESHEET_TIMEOUT_MS = 3000;
  var GA4_DESTINATION = 'G-VQC9CWT3R6';
  var EXCLUDED_PATHS = ['/cart', '/checkouts', '/account', '/policies'];
  var ISO_COUNTRIES = (
    'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ ' +
    'CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR ' +
    'GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO ' +
    'JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR ' +
    'MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO ' +
    'RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV ' +
    'TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'
  ).split(' ');
  var COUNTRY_MAP = {
    AE: {
      name: 'the UAE',
      origin: DESTINATION_ORIGIN,
      sourcePrefixes: []
    },
    EG: {
      name: 'Egypt',
      origin: DESTINATION_ORIGIN,
      sourcePrefixes: ['/en-egy']
    },
    SA: {
      name: 'Saudi Arabia',
      origin: DESTINATION_ORIGIN,
      sourcePrefixes: []
    }
  };

  var privacyReady = false;
  var pendingChoice = null;
  var dialogOpen = false;
  var previousFocus = null;
  var savedScrollStyles = null;

  function isIsoCountry(value) {
    return typeof value === 'string' && ISO_COUNTRIES.indexOf(value) !== -1;
  }

  function readConfig() {
    var element = document.getElementById(CONFIG_ID);

    if (!element) {
      return null;
    }

    try {
      var config = JSON.parse(element.textContent);

      if (!config || typeof config !== 'object' || Array.isArray(config)) {
        return null;
      }

      return config;
    } catch (error) {
      return null;
    }
  }

  function enabledCountriesFrom(value) {
    if (typeof value !== 'string') {
      return [];
    }

    return value.split(',').map(function (country) {
      return country.trim().toUpperCase();
    }).filter(function (country, index, countries) {
      return Object.prototype.hasOwnProperty.call(COUNTRY_MAP, country) && countries.indexOf(country) === index;
    });
  }

  function hasPathPrefix(pathname, prefix) {
    return pathname === prefix || pathname.indexOf(prefix + '/') === 0;
  }

  function sourcePrefixes() {
    var prefixes = [];

    Object.keys(COUNTRY_MAP).forEach(function (country) {
      COUNTRY_MAP[country].sourcePrefixes.forEach(function (prefix) {
        if (prefixes.indexOf(prefix) === -1) {
          prefixes.push(prefix);
        }
      });
    });

    return prefixes;
  }

  function stripSourcePrefix(pathname) {
    var cleanPath = pathname || '/';

    sourcePrefixes().some(function (prefix) {
      if (!hasPathPrefix(cleanPath, prefix)) {
        return false;
      }

      cleanPath = cleanPath.slice(prefix.length) || '/';
      return true;
    });

    return cleanPath.charAt(0) === '/' ? cleanPath : '/' + cleanPath;
  }

  function isExcludedPath(pathname) {
    var cleanPath = stripSourcePrefix(pathname);

    return EXCLUDED_PATHS.some(function (prefix) {
      return hasPathPrefix(cleanPath, prefix);
    });
  }

  function consumeBypass() {
    try {
      var currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(BYPASS_PARAMETER) !== 'us') {
        return false;
      }

      currentUrl.searchParams.delete(BYPASS_PARAMETER);

      try {
        window.history.replaceState(window.history.state, '', currentUrl.pathname + currentUrl.search + currentUrl.hash);
      } catch (error) {
        return true;
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  function privacyApi() {
    if (!privacyReady || !window.Shopify || !window.Shopify.customerPrivacy) {
      return null;
    }

    return window.Shopify.customerPrivacy;
  }

  function preferencesAllowed() {
    var api = privacyApi();

    if (!api || typeof api.preferencesProcessingAllowed !== 'function') {
      return false;
    }

    try {
      return api.preferencesProcessingAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function analyticsAllowed() {
    var api = privacyApi();

    if (!api || typeof api.analyticsProcessingAllowed !== 'function') {
      return false;
    }

    try {
      return api.analyticsProcessingAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function writeChoiceCookie(country, choice) {
    // Gate preference persistence on Shopify's preference processing permission.
    if (!preferencesAllowed() || !isIsoCountry(country) || (choice !== 'me' && choice !== 'us')) {
      return false;
    }

    try {
      var maxAge = COOKIE_DAYS * 24 * 60 * 60;
      // Gate the Domain attribute on the primary domain, so preview and myshopify hosts still persist the choice.
      var host = window.location.hostname;
      var domainAttribute = (host === 'wyrwear.com' || host.slice(-12) === '.wyrwear.com') ? '; Domain=.wyrwear.com' : '';
      document.cookie = COOKIE_NAME + '=v1|' + country + '|' + choice + '; Max-Age=' + maxAge + '; Path=/' + domainAttribute + '; SameSite=Lax; Secure';
      return true;
    } catch (error) {
      return false;
    }
  }

  function queueChoice(country, choice) {
    pendingChoice = { country: country, choice: choice };

    if (writeChoiceCookie(country, choice)) {
      pendingChoice = null;
    }
  }

  function flushPendingChoice() {
    if (!pendingChoice) {
      return;
    }

    if (writeChoiceCookie(pendingChoice.country, pendingChoice.choice)) {
      pendingChoice = null;
    }
  }

  function readChoiceCookie() {
    // Gate cookie reads on preference processing so no stored choice drives behavior before consent.
    if (!preferencesAllowed()) {
      return null;
    }

    try {
      var cookiePrefix = COOKIE_NAME + '=';
      var cookie = document.cookie.split(';').map(function (part) {
        return part.trim();
      }).filter(function (part) {
        return part.indexOf(cookiePrefix) === 0;
      })[0];

      if (!cookie) {
        return null;
      }

      var parts = cookie.slice(cookiePrefix.length).split('|');

      if (parts.length !== 3 || parts[0] !== 'v1' || !isIsoCountry(parts[1]) || (parts[2] !== 'me' && parts[2] !== 'us')) {
        return null;
      }

      return { country: parts[1], choice: parts[2] };
    } catch (error) {
      return null;
    }
  }

  function loadPrivacyApi() {
    return new Promise(function (resolve) {
      var settled = false;
      var timeoutId = window.setTimeout(function () {
        if (!settled) {
          settled = true;
          resolve(false);
        }
      }, PRIVACY_TIMEOUT_MS);

      function finish(loaded) {
        if (loaded) {
          privacyReady = true;
          flushPendingChoice();
        }

        if (!settled) {
          settled = true;
          window.clearTimeout(timeoutId);
          resolve(loaded);
        }
      }

      try {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          finish(false);
          return;
        }

        window.Shopify.loadFeatures([
          { name: 'consent-tracking-api', version: '0.1' }
        ], function (error) {
          finish(!error && !!window.Shopify.customerPrivacy);
        });
      } catch (error) {
        finish(false);
      }
    });
  }

  function onConsentCollected() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      privacyReady = true;
      flushPendingChoice();
    }
  }

  function debugCountry(config) {
    // Gate debug detection on a non-main theme role and a real ISO country code.
    if (config.themeRole === 'main') {
      return null;
    }

    try {
      var value = new URL(window.location.href).searchParams.get(DEBUG_PARAMETER);
      var country = typeof value === 'string' ? value.toUpperCase() : '';
      return isIsoCountry(country) ? country : null;
    } catch (error) {
      return null;
    }
  }

  function detectCountry(config) {
    var override = debugCountry(config);

    if (override) {
      return Promise.resolve(override);
    }

    return new Promise(function (resolve) {
      var settled = false;
      var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
      var timeoutId = window.setTimeout(function () {
        if (controller) {
          controller.abort();
        }

        if (!settled) {
          settled = true;
          resolve(null);
        }
      }, DETECTION_TIMEOUT_MS);

      function finish(country) {
        if (settled) {
          return;
        }

        settled = true;
        window.clearTimeout(timeoutId);
        resolve(country);
      }

      try {
        // Gate geolocation on Shopify's same-origin suggestion endpoint and fail open on every error.
        var routeRoot = window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string' ? window.Shopify.routes.root : '/';

        if (routeRoot.charAt(routeRoot.length - 1) !== '/') {
          routeRoot += '/';
        }

        var endpoint = new URL(routeRoot + 'browsing_context_suggestions.json?country[enabled]=true', window.location.origin);

        if (endpoint.origin !== window.location.origin) {
          finish(null);
          return;
        }

        var options = {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        };

        if (controller) {
          options.signal = controller.signal;
        }

        window.fetch(endpoint.href, options).then(function (response) {
          if (!response.ok) {
            return null;
          }

          return response.json();
        }).then(function (payload) {
          if (!payload || typeof payload !== 'object' || Array.isArray(payload) ||
              !payload.detected_values || typeof payload.detected_values !== 'object' || Array.isArray(payload.detected_values) ||
              !payload.detected_values.country || typeof payload.detected_values.country !== 'object' || Array.isArray(payload.detected_values.country) ||
              typeof payload.detected_values.country.handle !== 'string') {
            finish(null);
            return;
          }

          var country = payload.detected_values.country.handle;
          finish(isIsoCountry(country) ? country : null);
        }).catch(function () {
          finish(null);
        });
      } catch (error) {
        finish(null);
      }
    });
  }

  function buildDestination(country) {
    var market = COUNTRY_MAP[country];

    if (!market || market.origin !== DESTINATION_ORIGIN) {
      return null;
    }

    try {
      var destination = new URL(market.origin);
      destination.pathname = stripSourcePrefix(window.location.pathname);
      destination.search = window.location.search;
      destination.searchParams.delete('country');
      destination.searchParams.set('country', country);
      destination.hash = window.location.hash;

      return destination.origin === DESTINATION_ORIGIN ? destination.href : null;
    } catch (error) {
      return null;
    }
  }

  function navigate(destination, replace) {
    try {
      var validated = new URL(destination);

      // Gate every navigation on the exact approved destination origin.
      if (validated.origin !== DESTINATION_ORIGIN) {
        return;
      }

      if (replace) {
        window.location.replace(validated.href);
      } else {
        window.location.assign(validated.href);
      }
    } catch (error) {
      return;
    }
  }

  function sendEvent(name, country, target, callback) {
    var done = typeof callback === 'function' ? callback : function () {};

    // Gate analytics on Shopify's analytics processing permission.
    if (!analyticsAllowed() || typeof window.gtag !== 'function') {
      done();
      return;
    }

    var completed = false;
    var timeoutId = window.setTimeout(finish, EVENT_TIMEOUT_MS);

    function finish() {
      if (completed) {
        return;
      }

      completed = true;
      window.clearTimeout(timeoutId);
      done();
    }

    try {
      window.gtag('event', name, {
        send_to: GA4_DESTINATION,
        detected_country: country,
        target: target,
        event_callback: finish,
        event_timeout: EVENT_TIMEOUT_MS
      });
    } catch (error) {
      finish();
    }
  }

  function applyCopy(root, copy, country) {
    var market = COUNTRY_MAP[country];

    if (!market || !copy || typeof copy !== 'object') {
      return false;
    }

    var fields = [
      ['[data-wyr-region-gate-title]', copy.title],
      ['[data-wyr-region-gate-body]', copy.body],
      ['[data-wyr-region-gate-go]', copy.goLabel],
      ['[data-wyr-region-gate-stay]', copy.stayLabel]
    ];

    return fields.every(function (field) {
      var element = root.querySelector(field[0]);

      if (!element || typeof field[1] !== 'string') {
        return false;
      }

      element.textContent = field[1].split('{country}').join(market.name);
      return true;
    });
  }

  function lockScroll() {
    var documentElement = document.documentElement;
    var body = document.body;
    var scrollbarWidth = Math.max(0, window.innerWidth - documentElement.clientWidth);

    savedScrollStyles = {
      htmlOverflow: documentElement.style.overflow,
      bodyOverflow: body.style.overflow,
      bodyPaddingRight: body.style.paddingRight
    };

    documentElement.classList.add('wyr-region-gate-open');
    body.classList.add('wyr-region-gate-open');
    documentElement.style.overflow = 'hidden';
    body.style.overflow = 'hidden';

    if (scrollbarWidth > 0) {
      body.style.paddingRight = (parseFloat(window.getComputedStyle(body).paddingRight) + scrollbarWidth) + 'px';
    }
  }

  function unlockScroll() {
    if (!savedScrollStyles) {
      return;
    }

    document.documentElement.classList.remove('wyr-region-gate-open');
    document.body.classList.remove('wyr-region-gate-open');
    document.documentElement.style.overflow = savedScrollStyles.htmlOverflow;
    document.body.style.overflow = savedScrollStyles.bodyOverflow;
    document.body.style.paddingRight = savedScrollStyles.bodyPaddingRight;
    savedScrollStyles = null;
  }

  function focusableElements(dialog) {
    return Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return element.getAttribute('aria-hidden') !== 'true';
    });
  }

  function containFocus(event) {
    if (!dialogOpen) {
      return;
    }

    if (event.key === 'Escape' || event.keyCode === 27) {
      event.preventDefault();
      return;
    }

    if (event.key !== 'Tab' && event.keyCode !== 9) {
      return;
    }

    var dialog = document.querySelector('[data-wyr-region-gate-dialog]');

    if (!dialog) {
      return;
    }

    var focusable = focusableElements(dialog);

    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    }
  }

  function hideDialog(root) {
    if (!dialogOpen) {
      return;
    }

    dialogOpen = false;
    document.removeEventListener('keydown', containFocus);
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    root.removeAttribute('data-ready');
    unlockScroll();

    if (previousFocus && document.documentElement.contains(previousFocus) && typeof previousFocus.focus === 'function') {
      try {
        previousFocus.focus();
      } catch (error) {
        return;
      }
    }

    // Gate the hidden dialog from keeping keyboard focus when the page had no prior focus target.
    if (root.contains(document.activeElement) && document.activeElement && typeof document.activeElement.blur === 'function') {
      try {
        document.activeElement.blur();
      } catch (error) {
        return;
      }
    }
  }

  function whenStylesReady(callback) {
    var stylesheet = document.querySelector('[data-wyr-region-gate-stylesheet]');

    // Gate dialog activation on its asynchronously loaded stylesheet.
    if (!stylesheet) {
      return;
    }

    var completed = false;
    var timeoutId = window.setTimeout(function () {
      cleanup();
    }, STYLESHEET_TIMEOUT_MS);

    function cleanup() {
      if (completed) {
        return;
      }

      completed = true;
      window.clearTimeout(timeoutId);
      stylesheet.removeEventListener('load', ready);
      stylesheet.removeEventListener('error', cleanup);
    }

    function ready() {
      if (completed) {
        return;
      }

      cleanup();
      stylesheet.media = 'all';

      try {
        callback();
      } catch (error) {
        return;
      }
    }

    try {
      if (stylesheet.sheet) {
        ready();
        return;
      }

      stylesheet.addEventListener('load', ready);
      stylesheet.addEventListener('error', cleanup);
    } catch (error) {
      cleanup();
    }
  }

  function showDialog(config, country, destination) {
    var root = document.querySelector('[data-wyr-region-gate]');
    var dialog = root && root.querySelector('[data-wyr-region-gate-dialog]');
    var goButton = root && root.querySelector('[data-wyr-region-gate-go]');
    var stayButton = root && root.querySelector('[data-wyr-region-gate-stay]');

    if (!root || !dialog || !goButton || !stayButton || !applyCopy(root, config.copy, country)) {
      return;
    }

    whenStylesReady(function () {
      if (dialogOpen) {
        return;
      }

      previousFocus = document.activeElement;
      dialogOpen = true;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      root.setAttribute('data-ready', '');
      lockScroll();
      document.addEventListener('keydown', containFocus);

      goButton.addEventListener('click', function () {
        if (goButton.disabled) {
          return;
        }

        goButton.disabled = true;
        stayButton.disabled = true;
        queueChoice(country, 'me');
        sendEvent('wyr_region_gate_redirected', country, 'me', function () {
          navigate(destination, false);
        });
      }, { once: true });

      stayButton.addEventListener('click', function () {
        if (stayButton.disabled) {
          return;
        }

        queueChoice(country, 'us');
        hideDialog(root);
        sendEvent('wyr_region_gate_stayed', country, 'us');
      }, { once: true });

      try {
        dialog.focus({ preventScroll: true });
      } catch (error) {
        dialog.focus();
      }

      sendEvent('wyr_region_gate_shown', country, 'me');
    });
  }

  function handleCountry(config, enabledCountries, bypassActive, country) {
    if (!country) {
      return;
    }

    // Gate the store-switch bypass before any popup or redirect decision.
    if (bypassActive) {
      queueChoice(country, 'us');
      return;
    }

    // Gate activation on both the fixed country map and the merchant's enabled list.
    if (!COUNTRY_MAP[country] || enabledCountries.indexOf(country) === -1) {
      return;
    }

    var destination = buildDestination(country);

    if (!destination) {
      return;
    }

    var storedChoice = readChoiceCookie();

    // Gate stored choices on an exact match with the newly detected country.
    if (storedChoice && storedChoice.country === country && storedChoice.choice === 'us') {
      return;
    }

    if (storedChoice && storedChoice.country === country && storedChoice.choice === 'me') {
      sendEvent('wyr_region_gate_auto', country, 'me', function () {
        navigate(destination, true);
      });
      return;
    }

    showDialog(config, country, destination);
  }

  function init() {
    var config = readConfig();

    // Gate all work on the merchant's off-by-default theme setting.
    if (!config || config.enabled !== true) {
      return;
    }

    var enabledCountries = enabledCountriesFrom(config.enabledCountries);
    var bypassActive = consumeBypass();

    // Gate sensitive storefront routes before starting geolocation.
    if (!bypassActive && isExcludedPath(window.location.pathname)) {
      return;
    }

    document.addEventListener('visitorConsentCollected', onConsentCollected);

    Promise.all([
      detectCountry(config),
      loadPrivacyApi()
    ]).then(function (results) {
      handleCountry(config, enabledCountries, bypassActive, results[0]);
    }).catch(function () {
      return;
    });
  }

  function start() {
    try {
      init();
    } catch (error) {
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
